// D4/D6 — rangos de periodo anclados en una fecha (día/semana/mes/año). Nunca futuro.
export const shiftDays = (iso, n) => {
  const d = new Date(`${iso}T00:00:00Z`);
  d.setUTCDate(d.getUTCDate() + n);
  return d.toISOString().slice(0, 10);
};
export const todayIso = () => { const d = new Date(); return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 10); };
export const ISO_RX = /^\d{4}-\d{2}-\d{2}$/;
export const weekStartsMonday = () => !((typeof document !== 'undefined' && document.documentElement.getAttribute('lang')) || 'es').startsWith('en');

// Semana: lunes (es) / domingo (en).
export const anchoredRange = (period, anchor, weekMon = weekStartsMonday()) => {
  const today = todayIso();
  if (period === 'day') return { from: anchor, to: anchor };
  if (period === 'week') {
    const d = new Date(`${anchor}T00:00:00Z`); const dow = d.getUTCDay();
    const back = weekMon ? (dow + 6) % 7 : dow;
    const from = shiftDays(anchor, -back); const to = shiftDays(from, 6);
    return { from, to: to > today ? today : to };
  }
  if (period === 'month') {
    const [y, m] = anchor.split('-').map(Number);
    const from = `${y}-${String(m).padStart(2, '0')}-01`;
    const last = new Date(Date.UTC(y, m, 0)).getUTCDate();
    const to = `${y}-${String(m).padStart(2, '0')}-${String(last).padStart(2, '0')}`;
    return { from, to: to > today ? today : to };
  }
  if (period === 'year') {
    const y = anchor.slice(0, 4); const to = `${y}-12-31`;
    return { from: `${y}-01-01`, to: to > today ? today : to };
  }
  return null;
};

export const stepAnchor = (period, anchor, dir) => {
  if (period === 'day') return shiftDays(anchor, dir);
  if (period === 'week') return shiftDays(anchor, 7 * dir);
  const [y, m] = anchor.split('-').map(Number);
  const d = period === 'year' ? new Date(Date.UTC(y + dir, 0, 1)) : new Date(Date.UTC(y, m - 1 + dir, 1));
  return d.toISOString().slice(0, 10);
};

// ¿El rango anclado contiene HOY? (⇒ es el periodo actual)
export const isCurrent = (period, anchor, weekMon) => (anchoredRange(period, anchor, weekMon)?.to || '') >= todayIso();
